export default __webpack_public_path__ + "static/media/home-delivery.39636b1d.svg";